export const ActionTypesUser = {
    USER_SIGN_IN_REQUEST: 'USER_SIGN_IN_REQUEST',
    USER_SIGN_IN_ERROR: 'USER_SIGN_IN_ERROR',
    USER_SIGN_IN_SUCCESS: 'USER_SIGN_IN_SUCCESS',
    USER_SIGN_OUT_REQUEST: 'USER_SIGN_OUT_REQUEST',
    USER_SIGN_OUT_ERROR: 'USER_SIGN_OUT_ERROR',
    USER_SIGN_OUT_SUCCESS: 'USER_SIGN_OUT_SUCCESS'
}

export const ActionTypesUi = {
    SET_CHAT_CONFIG: 'SET_CHAT_CONFIG',
    UI_PULL_ERROR: 'UI_PULL_ERROR',
    SET_PLAYER_DATA: "SET_PLAYER_DATA",
    PLAYER_PULL_ERROR: "PLAYER_PULL_ERROR",
}

export const ActionTypesCommon = {
    SET_PAGE_CONFIG: 'SET_PAGE_CONFIG',
}

export const ActionTypesChat = {
    NEW_MESSAGE_RECEIVED: 'NEW_MESSAGE_RECEIVED',
    ADD_PARTICIPANT: 'ADD_PARTICIPANT',
    REMOVE_PARTICIPANT: 'REMOVE_PARTICIPANT',
    ENGAGEMENT_CREATED: 'ENGAGEMENT_CREATED',
    SET_SOCKET_CONNECTIVITY: 'SET_SOCKET_CONNECTIVITY',
    INIT_CHAT: 'INIT_CHAT',
    SET_SOCKET_INSTANCE: 'SET_SOCKET_INSTANCE',
}

export const ActionTypesEngagement = {
    CREATE_ENGAGEMENT_REQUEST: 'CREATE_ENGAGEMENT_REQUEST',
    CREATE_ENGAGEMENT_ERROR: 'CREATE_ENGAGEMENT_ERROR',
    CREATE_ENGAGEMENT_SUCCESS: 'CREATE_ENGAGEMENT_SUCCESS',
}